import Mutations from '../../odata/mutations';

export default { ...new Mutations('reason'), ...new Mutations('reasons') };
